import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ResponseCodeService } from '../../../../services/response-code.service';
import { NotificationService } from '../../../../services/notification.service';
import { AppState } from '../../../reducers';
import { Store } from '@ngrx/store';
import { Apollo } from 'apollo-angular';
import { map, switchMap } from 'rxjs/operators';

import * as fromActions from './uploadable-form-attachment.actions';
import * as fromGraphql from './uploadable-form-attachment.graphql';
import {GET_SERVICE_UPLOADABLE_FORM_ATTACHMENT} from "./uploadable-form-attachment.graphql";

@Injectable()
export class UploadableFormAttachmentEffects {

  createUploadableFormAttachment = createEffect(
    () =>
      this.actions$.pipe(ofType(fromActions.createUploadableFormAttachment), switchMap((action) => {
        return this.apollo
          .mutate({
            mutation: fromGraphql.CREATE_UPLOADABLE_FORM_ATTACHMENT,
            variables: {
              input: action?.input,
            },
          })
          .pipe(
            this.notificationService.catchError('Problem occurred while saving record'),
            map(({ data }: any) => {
              if (data) {
                const result: any = Object.values(data)[0];
                if (result?.response?.code == '9000') {
                  this.store.dispatch(
                    fromActions.upsertUploadableFormAttachment({
                      uploadableFormAttachment: result?.data,
                    })
                  );
                  return this.notificationService.successMessage('Created Successfully ');
                }

                this.notificationService.errorMessage(
                  result?.response?.message +
                  ' code:' +
                  result?.response?.code
                );
              }
            })
          );
      })
      ),
    { dispatch: false }
  );

  updateUploadableFormAttachment$ = createEffect(
    () =>
      this.actions$.pipe(ofType(fromActions.editUploadableFormAttachment), switchMap((action) => {
        return this.apollo
          .mutate({
            mutation: fromGraphql.UPDATE_UPLOADABLE_FORM_ATTACHMENT,
            variables: {
              input: action?.input,
            },
          })
          .pipe(
            this.notificationService.catchError('Problem occurred while updating record'), map(({ data }: any) => {
              if (data) {
                const result: any = Object.values(data)[0];
                if (result?.response?.code == '9000') {
                  this.store.dispatch(
                    fromActions.upsertUploadableFormAttachment({
                      uploadableFormAttachment: result?.data,
                    })
                  );
                  return this.notificationService.successMessage('Updated Successfully ');
                }

                this.notificationService.errorMessage(
                  result?.response?.message +
                  ' code:' +
                  result?.response?.code
                );
              }
            })
          );
      })
      ),
    { dispatch: false }
  );

  deleteUploadableFormAttachment$ = createEffect(
    () =>
      this.actions$.pipe(ofType(fromActions.removeUploadableFormAttachment), switchMap((action) => {
        return this.apollo
          .mutate({
            mutation: fromGraphql.DELETE_UPLOADABLE_FORM_ATTACHMENT,
            variables: {
              attachmentUniqueId: action?.attachmentUniqueId,
            },
          })
          .pipe(
            this.notificationService.catchError('Problem occurred while deleting record'), map(({ data }: any) => {
              if (data) {
                const result: any = Object.values(data)[0];
                if (result?.response?.code == '9000') {
                  this.store.dispatch(
                    fromActions.deleteUploadableFormAttachment({ id: action.id })
                  );
                  return this.notificationService.successMessage('Deleted Successfully');
                }

                this.notificationService.errorMessage(
                  result?.response?.message +
                  ' code:' +
                  result?.response?.code
                );
              }
            })
          );
      })
      ),
    { dispatch: false }
  );

  getUploadableFormAttachments$ = createEffect(
    () => {

      return this.actions$.pipe(ofType(fromActions.getUploadableFormAttachments), switchMap((action) => {
        return this.apollo
          .query({
            query: fromGraphql.GET_SERVICE_UPLOADABLE_FORM_ATTACHMENT,
            fetchPolicy: 'network-only',
            variables: {
              formUniqueId: action?.formUniqueId
            }
          })
          .pipe(
            this.notificationService.catchError('Problem occurred while fetching form'), map(({ data }: any) => {
              if (data) {
                const result: any = Object.values(data)[0];
                result?.response?.status
                  ? this.store.dispatch(
                    fromActions.loadUploadableFormAttachments({
                      uploadableFormAttachments: result?.data,
                    })
                  )
                  : [];
              }
            })
          );
      })
      )
    },
    { dispatch: false }
  );

  // CITIZEN
  citizenGetServiceUploadableFormAttachment$ = createEffect(() => {
      return this.actions$.pipe(ofType(fromActions.citizenGetServiceUploadableFormAttachment), switchMap((action) => {
        return this.apollo
          .query({
            query: fromGraphql.CITIZEN_GET_SERVICE_UPLOADABLE_FORM_ATTACHMENT,
            fetchPolicy: 'network-only',
            variables: {
              formUniqueId: action?.formUniqueId
            }
          })
          .pipe(
            this.notificationService.catchError('Problem occurred while fetching form'), map(({ data }: any) => {
              if (data) {
                const result: any = Object.values(data)[0];
                result?.response?.status
                  ? this.store.dispatch(
                    fromActions.loadUploadableFormAttachments({
                      uploadableFormAttachments: result?.data,
                    })
                  )
                  : [];
              }
            })
          );
      })
      )
    },
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) { }
}
